/**
 * api content types
 *
 * content types constants
 * content types checkers
 */

export const TEXT_TYPE = 'text/plain'
export const JSON_TYPE = 'application/json'
export const CSV_TYPE = 'text/csv'
export const ARRAY_BUFFER_TYPE = 'application/octet-stream'
export const MULTIPART_FORM_DATA_TYPE = 'multipart/form-data'

/**
 * check if content type is of the type
 *
 * @param {String} contentType - to test
 * @param {String|[String]} testType - types to test if is of the type
 * @return {Boolean} true if contentType matches test types
 */
export function isType(contentType, testType) {
  if (Array.isArray(testType)) {
    return testType.some(type => isType(contentType, type))
  }
  return contentType.includes(testType)
}

/**
 * check if content type is text or csv types
 *
 * @param {String} contentType - to test
 * @return {Boolean} true if content type is TEXT_TYPE or CSV_TYPE
 */
export function isTextType(contentType) {
  return isType(contentType, [TEXT_TYPE, CSV_TYPE])
}

/**
 * check if content type is json type
 *
 * @param {String} contentType - to test
 * @return {Boolean} true if content type is JSON_TYPE
 */
export function isJSONType(contentType) {
  return isType(contentType, JSON_TYPE)
}

/**
 * check if content type is array buffer type
 *
 * @param {String} contentType - to test
 * @return {Boolean} true if content type is ARRAY_BUFFER_TYPE
 */
export function isArrayBufferType(contentType) {
  return isType(contentType, ARRAY_BUFFER_TYPE)
}

/**
 * check if content type is multipart form data type
 *
 * @param {String} contentType - to test
 * @return {Boolean} true if content type is MULTIPART_FORM_DATA_TYPE
 */
export function isMultipartFormData(contentType) {
  return isType(contentType, MULTIPART_FORM_DATA_TYPE)
}
